import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import GelLaneSelectImage from "./img/gel-top.svg";
import { Image } from "@learningblocks/shared-components/lib/Image";

export function GelLaneSelect(props) {
  const { t } = useTranslation();

  const setGelActiveLane = (activeLane) => {
    props.setGelActiveLane({
      id: 1,
      activeLane,
    });
  };

  const getLanes = () => {
    const lanes = [];

    for (const lane in props.lanes) {
      lanes.push({
        lane: lane.replace("lane", "Lane "),
        contents:
          props.lanes[lane].solutionAlias !== ""
            ? props.lanes[lane].solutionAlias
            : "[Empty]",
      });
    }

    return (
      <div className={`${props.className}_lanes_wrapper`}>
        {lanes.map((lane, index) => (
          <div className={`${props.className}_lanes_wrapper_lane`}>
            <div
              role="button"
              tabIndex={0}
              className={
                "laneSelect" +
                (lane.contents === "[Empty]"
                  ? lane.lane.replace("Lane ", "lane") == props.selectedLane
                    ? " empty selected"
                    : " empty"
                  : "")
              }
              onClick={() => {
                if (lane.contents === "[Empty]") {
                  const selectedLane = lane.lane.replace("Lane ", "lane");
                  const selectedLaneNumber = lane.lane.replace("Lane ", "");
                  props.setSelectedLane(selectedLane);
                  setGelActiveLane(selectedLaneNumber);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  if (lane.contents === "[Empty]") {
                    const selectedLane = lane.lane.replace("Lane ", "lane");
                    const selectedLaneNumber = lane.lane.replace("Lane ", "");
                    props.setSelectedLane(selectedLane);
                    setGelActiveLane(selectedLaneNumber);
                  }
                }
              }}
            >
              <b className={lane.contents === "[Empty]" ? "empty" : ""}>
                {index + 1}
              </b>
            </div>
            <div
              className={"well" + (lane.contents === "[Empty]" ? " empty" : "")}
            ></div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={props.className}>
      <div className={`${props.className}_lanes`}>{getLanes()}</div>
      <div className={`${props.className}_image`}>
        <Image
          src={GelLaneSelectImage}
          alt={t("ControlsPanel.string")}
          style={{
            transform: props.orientation === 360 ? "rotate(180deg)" : null,
          }}
          className={`${props.className}_image_main`}
        />
      </div>
    </div>
  );
}

GelLaneSelect.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
};

GelLaneSelect.defaultProps = {};
